import { Flex } from '@chakra-ui/react';

export const TiptapMenubar = (props: any) => (
   <Flex
      bgColor="gray.50"
      borderWidth={1}
      borderColor="gray.300"
      borderRadius="md"
      position="sticky"
      p={1}
      top={0}
      zIndex={1}
      flexWrap="wrap"
      {...props}
   >
      {props.children}
   </Flex>
);
